import React from 'react'
import { Search } from 'react-feather'
import { useSelector } from 'react-redux'

const SearchInput = ({disabled, onSearchSubmit = (e) => {console.log(e)}, className, ...props}) => {
  const language = useSelector(state => state.system.language)
  const translation = useSelector(state => state.translation.data)

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if(!disabled){
        onSearchSubmit()
      }
    }
  }

  return (
    <div className="flex items-center cursor-pointer w-full relative">
      <input
        className={`input w-full border border-gray-400 rounded py-2 px-4 ${className}`}
        placeholder={`${translation.SEARCH.search[language.name]}...`}
        style={{borderColor: '#ddd'}}
        disabled={disabled}
        onKeyDown={handleKeyDown}
        {...props}
      />
      <Search
        style={{width: '16px', height: '16px', color: '#999'}}
        className={`absolute w-full right-0 mr-3`}
        onClick={disabled ? () => {} : () => onSearchSubmit()}
      />
    </div>
  )
}

export { SearchInput }
